export const CHECKBOX_CHECKED_VALUE = 'true'

// Filled by the form-generation lambda from order data, so not entered manually
export const ORDER_INFORMATION_FIELD_KEYS = [
  'patientName', 'patientFirstName', 'patientLastName', 'patientMiddleName',
  'patientDob', 'patientAddress', 'patientDeliveryAddress', 'patientCity',
  'patientState', 'patientZip', 'patientHeight', 'patientWeight',
  'patientAge', 'patientGender', 'patientPhone', 'patientEmail',
  'patientHomePhone', 'patientMobilePhone', 'insuranceMemberId',
  'secondaryInsuranceMemberId', 'insuranceGroup', 'secondaryInsuranceGroup',
  'physicianName', 'physicianLastName', 'physicianFirstName', 'physicianMiddleName',
  'physicianNpi', 'physicianPhone', 'physicianFax',
  'physicianAddress', 'physicianCity', 'physicianState', 'physicianZip',
  'generationDate', 'officeName', 'officeAddress', 'officeCity', 'officeZip',
  'officeState', 'officePhone', 'officeFax', 'officeNpi',
  'orderId', 'deviceModel', 'deviceManufacturer', 'deviceSerial',
]
